import { useState } from "react";
import { faqs } from "@/mocks/naruto";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-bold text-primary-600">
            <i className="ri-question-line"></i> 帮助中心
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">
            常见问题解答
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            关于火影同人动漫，你关心的问题这里都有答案。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                    {faq.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${
                      isOpen ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-50 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}